import { Component } from 'react';

const CURSOR_POSTITION_THRESHOLD = 0;

export default class OverlayUIElement extends Component {
    constructor(props) {
        super(props);

        this.overlayElement = null;
        this.overlayParentElement = null;
        this.overlayElementIsInDom = false;

        this.handleOverlayWindowResize = this.handleOverlayWindowResize.bind(this);
        this.handleOverlayWindowScroll = this.handleOverlayWindowScroll.bind(this);
    }

    setOverlayElement(element, parent) {
        if (!element) {
            return;
        }

        if (!parent) {
            parent = element.parentNode;
        }

        this.overlayElement = element
        this.setOverlayParentElement(parent);
    }

    setOverlayParentElement(element) {
        this.overlayParentElement = element;
    }

    destroyOverlay() {
        this.stopListeningForPositionChange();
    }

    getCursorPosition(event) {
        if (event) {
            const eventPosition = {
                x: event.clientX,
                y: event.clientY
            }

            this.storedPosition = eventPosition;

            return eventPosition;
        }

        return this.storedPosition;
    }

    handleOverlayElementShow(event) {
        if (!this.overlayElement) {
            return;
        }

        this.positionOverlayElement(event);
        this.listenForOverlayElementPositionChange();
    }

    handleOverlayElementHide() {
        this.stopListeningForPositionChange();
    }

    listenForOverlayElementPositionChange() {
        window.addEventListener('resize', this.handleOverlayWindowResize);
        window.addEventListener('scroll', this.handleOverlayWindowScroll, true);
    }

    stopListeningForPositionChange() {
        window.removeEventListener('resize', this.handleOverlayWindowResize);
        window.removeEventListener('scroll', this.handleOverlayWindowScroll);
    }

    handleOverlayWindowResize() {
        this.positionOverlayElement();
    }

    handleOverlayWindowScroll() {
        this.positionOverlayElement();
    }

    positionOverlayElement(event) {
        if (!this.overlayElement) {
            return;
        }

        const positioningThreshold = 8;
        const elementRect = this.overlayElement.getBoundingClientRect();
        const parentRect = this.overlayParentElement && this.overlayParentElement.getBoundingClientRect();
        let xPosition = this.props.defaultXPosition || 'right';
        let yPosition = this.props.defaultYPosition || 'bottom';
        let parentX;
        let parentY;
        let parentTop;
        let xAlign = this.props.xAlign;
        let yAlign = this.props.yAlign;

        if (this.props.cursorPosition) {
            const position = this.getCursorPosition(event);

            if (!position) {
                return;
            }

            parentX = position.x - CURSOR_POSTITION_THRESHOLD;
            parentY = parentTop = position.y - CURSOR_POSTITION_THRESHOLD;
        } else {
            if (!this.overlayParentElement) {
                return;
            }

            parentX = parentRect.left + parentRect.width / 2;
            parentY = parentRect.top + parentRect.height;
            parentTop = parentRect.top;

            if (xAlign === 'right') {
                parentX = parentRect.left + parentRect.width;
            } else if (xAlign === 'left') {
                parentX = parentRect.left;
            }

            if (yAlign === 'top') {
                parentY = parentRect.top;
            }

            if (yAlign === 'center') {
                parentY = parentRect.top + parentRect.height / 2;
            }
        }

        if (xPosition === 'center') {
            if (parentX + elementRect.width / 2 + positioningThreshold > window.innerWidth) {
                xPosition = 'left';
            } else if (parentX - elementRect.width / 2 - positioningThreshold < 0) {
                xPosition = 'right';
            }
        }

        if (xPosition === 'right' && parentX + elementRect.width + positioningThreshold > window.innerWidth) {
            xPosition = 'left';

            if (xAlign === 'left') {
                xAlign = 'right';
                parentX = parentRect.left + parentRect.width;
            }
        }

        if (xPosition === 'left' && parentX - elementRect.width - positioningThreshold < 0) {
            xPosition = 'right';
        }

        if (yPosition === 'top' && parentY - elementRect.height - positioningThreshold < 0) {
            yPosition = 'bottom';
        }

        if (!this.props.inside && yPosition === 'bottom' && parentY + elementRect.height + positioningThreshold > window.innerHeight) {
            const maxHeight = window.innerHeight - parentY - positioningThreshold;

            if ((!this.props.resizeToFit || maxHeight < this.props.minHeight) && parentY - elementRect.height - positioningThreshold > 0) {
                yPosition = 'top';
            } else {
                const element = this.overlayElement.querySelector('.popout-inner') || this.overlayElement;

                element.style.maxHeight = `${maxHeight}px`;
            }
        }

        if (xPosition === 'right') {
            this.overlayElement.style.left = `${parentX}px`;
        } else if (xPosition === 'center') {
            this.overlayElement.style.left = `${parentX - elementRect.width / 2}px`;
        } else {
            this.overlayElement.style.left = `${parentX - elementRect.width}px`;
        }

        if (yPosition === 'bottom') {
            if (yAlign === 'bottom') {
                this.overlayElement.style.top = `${parentY - elementRect.height}px`;
            } else if (xAlign !== xPosition && !this.props.cursorPosition) {
                this.overlayElement.style.top = `${parentTop + parentRect.height}px`;
            } else {
                this.overlayElement.style.top = `${parentY}px`;
            }
        } else {
            if (yAlign === 'top') {
                this.overlayElement.style.top = `${parentY - elementRect.height}px`;
            } else if (yAlign === 'center') {
                this.overlayElement.style.top = `${parentY - elementRect.height / 2}px`;
            } else {
                this.overlayElement.style.top = `${parentTop - elementRect.height}px`;
            }
        }

        this.overlayElement.setAttribute('x-position', xPosition);
        this.overlayElement.setAttribute('y-position', yPosition);

        xAlign && this.overlayElement.setAttribute('x-align', xAlign);
        yAlign && this.overlayElement.setAttribute('y-align', yAlign);
    }

    handleOverlayParentDestroy() {
        this.destroyOverlay();
    }
}
